// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"31d6cfe0","986":"31d6cfe0"}[chunkId] + ".chunk.css";
};